(function () {
    const body = document.body;
    const head = document.getElementById('gh-head');
    const burger = head ? head.querySelector('.gh-burger') : null;
    const menu = document.getElementById('gh-head-menu');
    const mobileQuery = window.matchMedia('(max-width: 767px)');
    const focusableSelector = [
        'a[href]',
        'button:not([disabled])',
        'input:not([disabled]):not([type="hidden"])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])',
        'summary'
    ].join(',');

    let previousFocus = null;

    function isVisible(element) {
        return Boolean(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    }

    function getMenuFocusableItems() {
        if (!head) {
            return [];
        }

        return Array.from(head.querySelectorAll(focusableSelector)).filter(isVisible);
    }

    function setMenuState(isOpen, shouldRestoreFocus) {
        if (!burger) {
            return;
        }

        if (isOpen) {
            previousFocus = document.activeElement;
            body.classList.add('gh-head-open');
            burger.setAttribute('aria-expanded', 'true');
            burger.setAttribute('aria-label', 'Close main menu');

            const firstMenuLink = menu ? menu.querySelector(focusableSelector) : null;
            window.setTimeout(function () {
                (firstMenuLink || burger).focus();
            }, 0);

            return;
        }

        body.classList.remove('gh-head-open');
        burger.setAttribute('aria-expanded', 'false');
        burger.setAttribute('aria-label', 'Open main menu');

        if (menu) {
            menu.querySelectorAll('details[open]').forEach(function (details) {
                details.removeAttribute('open');
            });
        }

        if (shouldRestoreFocus && previousFocus && typeof previousFocus.focus === 'function') {
            previousFocus.focus();
        }
    }

    function trapMenuFocus(event) {
        if (!body.classList.contains('gh-head-open') || event.key !== 'Tab') {
            return;
        }

        const focusableItems = getMenuFocusableItems();
        if (!focusableItems.length) {
            event.preventDefault();
            return;
        }

        const firstItem = focusableItems[0];
        const lastItem = focusableItems[focusableItems.length - 1];

        if (event.shiftKey && document.activeElement === firstItem) {
            event.preventDefault();
            lastItem.focus();
        } else if (!event.shiftKey && document.activeElement === lastItem) {
            event.preventDefault();
            firstItem.focus();
        }
    }

    if (burger) {
        burger.addEventListener('click', function () {
            setMenuState(!body.classList.contains('gh-head-open'), false);
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && body.classList.contains('gh-head-open')) {
                event.preventDefault();
                setMenuState(false, true);
            }

            trapMenuFocus(event);
        });

        if (menu) {
            menu.addEventListener('click', function (event) {
                const link = event.target.closest('a[href]');
                if (link && mobileQuery.matches) {
                    setMenuState(false, false);
                }
            });
        }

        const handleViewportChange = function (event) {
            if (!event.matches) {
                setMenuState(false, false);
            }
        };

        if (typeof mobileQuery.addEventListener === 'function') {
            mobileQuery.addEventListener('change', handleViewportChange);
        } else if (typeof mobileQuery.addListener === 'function') {
            mobileQuery.addListener(handleViewportChange);
        }
    }
})();

(function () {
    const content = document.querySelector('.gh-content');
    if (!content || document.getElementById('fit-vids-style')) {
        return;
    }

    const style = document.createElement('style');
    style.id = 'fit-vids-style';
    style.textContent = '.fluid-width-video-container{flex-grow:1;width:100%;}.fluid-width-video-wrapper{position:relative;width:100%;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed{position:absolute;top:0;left:0;width:100%;height:100%;}';
    document.head.appendChild(style);

    const selectors = [
        'iframe[src*="player.vimeo.com"]',
        'iframe[src*="youtube.com"]',
        'iframe[src*="youtube-nocookie.com"]',
        'iframe[src*="kickstarter.com"][src*="video.html"]',
        'object',
        'embed'
    ];

    content.querySelectorAll(selectors.join(',')).forEach(function (video, index) {
        if (video.closest('.fitvidsignore, .fluid-width-video-wrapper') || (video.tagName.toLowerCase() === 'embed' && video.closest('object'))) {
            return;
        }

        const width = parseInt(video.getAttribute('width'), 10) || video.clientWidth || 16;
        const height = parseInt(video.getAttribute('height'), 10) || video.clientHeight || 9;
        const ratio = height / width;
        const container = document.createElement('div');
        const wrapper = document.createElement('div');

        container.className = 'fluid-width-video-container';
        wrapper.className = 'fluid-width-video-wrapper';
        wrapper.style.paddingTop = (ratio * 100) + '%';

        if (!video.getAttribute('name')) {
            video.setAttribute('name', 'fitvid' + index);
        }

        video.removeAttribute('height');
        video.removeAttribute('width');
        video.parentNode.insertBefore(container, video);
        container.appendChild(wrapper);
        wrapper.appendChild(video);
    });
})();

(function () {
    document.addEventListener('error', function (event) {
        const image = event.target;
        if (!image || !image.matches || !image.matches('.post-card-image[data-fallback-src]')) {
            return;
        }

        const fallbackSrc = image.getAttribute('data-fallback-src');
        if (!fallbackSrc || image.src === fallbackSrc) {
            return;
        }

        image.removeAttribute('srcset');
        image.src = fallbackSrc;

        const imageLink = image.closest('.post-card-image-link');
        if (imageLink) {
            imageLink.classList.add('is-fallback');
        }
    }, true);
})();
